// hooks/useRiskResults.ts
import { useAppSelector } from '@/shared/lib/hooks/useAppSelector';
import { useMemo } from 'react';

interface RiskItem {
    id: string;
    title: string;
    description: string;
    level: 'low' | 'middle' | 'high';
    icon: string;
}

const RISK_META: Record<string, { title: string; icon: string }> = {
    digestive: {
        title: 'Заболевания желудочно-кишечного тракта',
        icon: '/img/r6.svg',
    },
    immunity: {
        title: 'Снижение общего иммунитета',
        icon: '/img/r1.svg',
    },
    reproductive: {
        title: 'Расстройство репродуктивной системы',
        icon: '/img/r3.svg',
    },
    cardio: {
        title: 'Сердечно-сосудистые заболевания',
        icon: '/img/r4.svg',
    },
    diabetes: {
        title: 'Диабет',
        icon: '/img/r8.svg',
    },
    liver: {
        title: 'Заболевания печени',
        icon: '/img/r10.svg',
    },
    thyroid: {
        title: 'Расстройство нервной системы',
        icon: '/img/r5.svg',
    },
    bones: {
        title: 'Хрупкость костей',
        icon: '/img/r7.svg',
    },
    lungs: {
        title: 'Ухудшение зрения',
        icon: '/img/r2.svg',
    },
    skin: {
        title: 'Деменция',
        icon: '/img/r9.svg',
    },
};

export const useRiskResults = (): { data: RiskItem[]; loading: boolean } => {
    const riskResult = useAppSelector((state) => state.questionnaire.riskResult);

    const convertLevel = (level: string): 'low' | 'middle' | 'high' => {
        if (level === 'medium') return 'middle';
        if (level === 'high') return 'high';
        return 'low';
    };

    const data = useMemo(() => {
        if (!riskResult?.risks) return [];


        return riskResult.risks
            .map((a): RiskItem | null => {
                const map: Record<string, string> = {
                    immune_deficiency: 'immunity',
                    vision: 'skin',
                    reproductive: 'reproductive',
                    cardio: 'cardio',
                    nervous: 'thyroid',
                    digestive: 'digestive',
                    bone_joint: 'bones',
                    diabetes: 'diabetes',
                    dementia: 'lungs',
                    liver: 'liver',
                };

                const mappedId = map[a.risk_code];
                const meta = RISK_META[mappedId];

                if (!meta) return null;

                return {
                    id: mappedId,
                    title: meta.title,
                    description: a.explanation,
                    level: convertLevel(a.level),
                    icon: meta.icon,
                };
            })
            .filter(Boolean) as RiskItem[];
    }, [riskResult]);

    return { data, loading: !riskResult };
};
